document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.lp-hero');
  const pill = document.querySelector('.lp-hero__pill');
  if (!hero || !pill) return;

  let isFixed = false;

  const flipToState = (nextFixed) => {
    // 1) FIRST: aktuelle Position messen
    const first = pill.getBoundingClientRect();

    // 2) Klasse umschalten (Layout ändert sich)
    document.body.classList.toggle('lp-pill-fixed', nextFixed);

    // 3) LAST: neue Position messen
    const last = pill.getBoundingClientRect();

    // 4) INVERT: Differenz berechnen
    const dx = first.left - last.left;
    const dy = first.top - last.top;

    // 5) PLAY: per transform "zurückspringen" und dann animiert auf 0
    pill.style.willChange = 'transform';
    pill.style.transition = 'none';
    pill.style.transform = `translate(${dx}px, ${dy}px)`;

    requestAnimationFrame(() => {
      pill.style.transition = 'transform 320ms ease';
      pill.style.transform = ''; // zurück zur CSS-Position

      // Cleanup nach Animation
      const cleanup = () => {
        pill.style.willChange = '';
        pill.style.transition = '';
        pill.style.transform = '';
        pill.removeEventListener('transitionend', cleanup);
      };
      pill.addEventListener('transitionend', cleanup);
    });
  };

  const update = () => {
    const heroHeight = hero.offsetHeight;
    const shouldBeFixed = window.scrollY > heroHeight - 100;

    if (shouldBeFixed !== isFixed) {
      isFixed = shouldBeFixed;
      flipToState(isFixed);
    }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', () => {
    // Beim Resize Zustand neu setzen ohne Jump
    isFixed = false;
    document.body.classList.remove('lp-pill-fixed');
    update();
  });
});
